import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var Indeterminate = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { d: "M27 2a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h22zm-3.333 12.667H8.334a1.333 1.333 0 0 0-.128 2.66l.128.006h15.333a1.333 1.333 0 0 0 .128-2.66l-.128-.006z" }))); }));
Indeterminate.displayName = 'Indeterminate';
Indeterminate['iconName'] = 'indeterminate';
export default Indeterminate;
